var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wrapper" },
    [
      _c("div", { staticClass: "preview" }, [
        _c(
          "div",
          { staticClass: "preview__content" },
          [
            _vm.handling
              ? _c("c-loader", {
                  staticClass: "loader",
                  attrs: { active: _vm.handling },
                })
              : _vm.filePreviewUrl
              ? _c("img", {
                  staticClass: "preview-img",
                  attrs: { src: _vm.filePreviewUrl, alt: "" },
                  on: {
                    click: function ($event) {
                      return _vm.openFile()
                    },
                  },
                })
              : _c("img", {
                  staticClass: "preview-empty",
                  attrs: { src: "/redesign/img/userpic.svg" },
                  on: {
                    click: function ($event) {
                      return _vm.chooseFile()
                    },
                  },
                }),
          ],
          1
        ),
        _vm.field.required
          ? _c("div", { staticClass: "required-mark" })
          : _vm._e(),
      ]),
      _c("input", {
        ref: "input",
        attrs: {
          name: "attachment[]",
          type: "file",
          accept: _vm.accept,
          hidden: "",
          required: _vm.field.required,
        },
        on: { change: _vm.onFileChange },
      }),
      _c("div", { staticClass: "actions" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "b-popover",
                rawName: "v-b-popover.html",
                value: {
                  container: "#app",
                  trigger: "hover blur",
                  content: "Загрузить фотографию",
                  placement: "top",
                },
                expression:
                  "{\n        container: '#app',\n        trigger: 'hover blur',\n        content: 'Загрузить фотографию',\n        placement: 'top',\n      }",
                modifiers: { html: true },
              },
            ],
            staticClass: "change",
          },
          [
            _c("c-button", {
              attrs: {
                size: "iconic",
                icon: { icon: "restore" },
                disabled: _vm.preview,
              },
              on: {
                click: function ($event) {
                  return _vm.chooseFile()
                },
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "b-popover",
                rawName: "v-b-popover.html",
                value: {
                  container: "#app",
                  trigger: "hover blur",
                  content: "Удалить фотографию",
                  placement: "top",
                },
                expression:
                  "{\n        container: '#app',\n        trigger: 'hover blur',\n        content: 'Удалить фотографию',\n        placement: 'top',\n      }",
                modifiers: { html: true },
              },
            ],
            staticClass: "remove",
          },
          [
            _c("c-button", {
              attrs: {
                size: "iconic",
                icon: { icon: "trash", color: "secondary" },
                disabled: _vm.preview || !_vm.filePreviewUrl,
              },
              on: {
                click: function ($event) {
                  return _vm.removeFile()
                },
              },
            }),
          ],
          1
        ),
      ]),
      _vm.sizeError
        ? _c("error-feedback", {
            attrs: { text: "Размер файла не должен превышать 5Мб" },
          })
        : _vm._e(),
      _vm.error
        ? _c("error-feedback", { attrs: { text: _vm.error } })
        : _vm._e(),
      _c("FsLightbox", {
        key: _vm.gallery.length,
        attrs: {
          toggler: _vm.lightbox,
          sources: _vm.gallery,
          "disable-local-storage": true,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }